var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import * as ServiceActivite from '../../services/activite';
import * as ServiceUtils from '../../services/utils';
import { Loader } from '../../utils/Loader';
import { FormikGenerator, TYPES } from '../../utils/FormikGenerator';
import { ActiviteIcon, AddIcon, CollaborateurIcon, ContactIcon, DeleteIcon, } from '../../utils/Icons';
import { Modal } from '../../utils/Modal';
import { CardTitle } from '../../utils/CardTitle';
import { IconButton } from '../../utils/IconButton';
import { Chip, Stack, Tooltip } from '@mui/material';
import { FieldArray } from 'formik';
import { ActiviteSchema } from '../../utils/ValidationSchema';
import moment from 'moment';
import { getIsMobile } from '../../services/utilisateur';
export var EditionActivite = function (props) {
    var isMobile = getIsMobile();
    var ActiviteId = props.ActiviteId, ClientId = props.ClientId, handleClose = props.handleClose;
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState(null), activite = _b[0], setActivite = _b[1];
    var _c = useState([]), typesActivite = _c[0], setTypesActivite = _c[1];
    var _d = useState([]), contacts = _d[0], setContacts = _d[1];
    var _e = useState([]), collaborateurs = _e[0], setCollaborateurs = _e[1];
    var _f = useState([]), tags = _f[0], setTags = _f[1];
    useEffect(function () {
        var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var datas;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, Promise.all([
                                ServiceActivite.getActivite(ActiviteId, ClientId),
                                ServiceUtils.getTypes('Activite'),
                                ServiceUtils.getSelectOptions('contacts', { ClientId: ClientId }),
                                ServiceUtils.getSelectOptions('collaborateurs'),
                                ServiceUtils.getTypes('Tag'),
                            ])];
                    case 1:
                        datas = _a.sent();
                        setActivite(datas[0]);
                        setTypesActivite(datas[1]);
                        setContacts(datas[2]);
                        setCollaborateurs(datas[3]);
                        setTags(datas[4]);
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        getData();
    }, []);
    var renderForm = function () {
        return (_jsxs(_Fragment, { children: [!!activite.IsLectureSeule && (_jsx(Tooltip, __assign({ disableInteractive: true, title: activite.IsLectureSeule }, { children: _jsx(Chip, { color: "error", label: "Activit\u00E9 non modifiable" }) }))), _jsx(FormikGenerator, { validationSchema: ActiviteSchema, submitLabel: ActiviteId ? 'Enregistrer' : 'Ajouter', datas: activite, validate: function (_a) {
                        var values = _a.values;
                        if (!values.activite__collaborateurs ||
                            values.activite__collaborateurs.filter(function (collaborateur) { return !collaborateur.Deleted; }).length === 0) {
                            return 'Un collaborateur est obligatoire';
                        }
                    }, onSubmit: function (activite) { return __awaiter(void 0, void 0, void 0, function () {
                        var isOk;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, ServiceActivite.postActivite(ClientId, ActiviteId, activite)];
                                case 1:
                                    isOk = (_a.sent()).isOk;
                                    if (isOk) {
                                        handleClose();
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); }, additionalInitialValues: [
                        'UseSynchroCalendar',
                        'activite__collaborateurs',
                        'activite__contacts',
                    ], fields: [
                        [
                            {
                                xs: 3,
                                name: 'ActiviteTypeId',
                                label: 'Type',
                                type: TYPES.SELECT,
                                options: typesActivite,
                                disabled: !!activite.IsLectureSeule,
                            },
                            {
                                xs: 3,
                                name: 'DateDebut',
                                label: 'Date de début',
                                afterChange: function (value, values, setFieldValue) {
                                    var DateDebut = moment(new Date(value));
                                    if (DateDebut.isValid()) {
                                        setFieldValue('DateFin', values.DureeActivite
                                            ? DateDebut.add(values.DureeActivite ? values.DureeActivite : 0, 'minute')
                                            : DateDebut);
                                    }
                                },
                                type: TYPES.TEXT,
                                datetimePicker: true,
                                disabled: !!activite.IsLectureSeule,
                            },
                            {
                                xs: 3,
                                name: 'DureeActivite',
                                label: 'Durée (minutes)',
                                type: TYPES.TEXT,
                                onlyDigits: true,
                                afterChange: function (value, values, setFieldValue) {
                                    if (values.DateDebut) {
                                        var DateDebut = moment(new Date(values.DateDebut));
                                        if (DateDebut.isValid()) {
                                            setFieldValue('DateFin', DateDebut.add(value ? value : 0, 'minute'));
                                        }
                                    }
                                },
                                disabled: !!activite.IsLectureSeule,
                            },
                            {
                                xs: 3,
                                name: 'DateFin',
                                label: 'Date de fin',
                                type: TYPES.TEXT,
                                datetimePicker: true,
                                afterChange: function (value, values, setFieldValue) {
                                    if (values.DateDebut && value) {
                                        var DateDebut = moment(new Date(values.DateDebut));
                                        var DateFin = moment(new Date(value));
                                        if (DateDebut.isValid() && DateFin.isValid()) {
                                            setFieldValue('DureeActivite', DateFin.diff(DateDebut, 'minute'));
                                        }
                                    }
                                },
                                disabled: !!activite.IsLectureSeule,
                            },
                            {
                                xs: 6,
                                name: 'Tags',
                                label: 'Tags',
                                type: TYPES.SELECT,
                                options: tags,
                                multiple: true,
                                disabled: !!activite.IsLectureSeule,
                            },
                            {
                                xs: 3,
                                name: 'Etat',
                                label: 'État',
                                type: TYPES.SELECT,
                                options: Object.entries(activite.getEtats).map(function (_a) {
                                    var value = _a[0], label = _a[1];
                                    return { label: label, value: value };
                                }),
                                disabled: !!activite.IsLectureSeule,
                            },
                            {
                                xs: 3,
                                name: 'Resultat',
                                label: 'Résultat',
                                type: TYPES.SELECT,
                                options: Object.entries(activite.getResultats).map(function (_a) {
                                    var value = _a[0], label = _a[1];
                                    return { label: label, value: value };
                                }),
                                isRequired: true,
                                show: function (values) { return values.Etat === 'C'; },
                                disabled: !!activite.IsLectureSeule,
                            },
                        ],
                        [
                            {
                                xs: 12,
                                name: 'Commentaire',
                                label: 'Commentaire',
                                type: TYPES.TEXT,
                                multiline: true,
                                disabled: !!activite.IsLectureSeule,
                            },
                        ],
                    ], renderContent: function (_a) {
                        var values = _a.values, renderField = _a.renderField, setFieldValue = _a.setFieldValue;
                        return (_jsxs(Stack, __assign({ className: "mt-small", direction: isMobile ? 'column' : 'row', spacing: 2 }, { children: [_jsxs(Stack, __assign({ className: "w-full", spacing: 2 }, { children: [_jsx(CardTitle, { title: 'Collaborateurs', startIcon: _jsx(CollaborateurIcon, {}), color: "collaborateur", renderButtons: function () { return (_jsx(_Fragment, { children: _jsx(IconButton, __assign({ tooltip: "Ajouter", color: "white", onClick: function () {
                                                        setFieldValue('activite__collaborateurs', __spreadArray(__spreadArray([], (values.activite__collaborateurs
                                                            ? values.activite__collaborateurs
                                                            : []), true), [
                                                            {
                                                                IsNew: true,
                                                                IdActiviteCollaborateur: null,
                                                                CollaborateurId: null,
                                                                ActiviteId: ActiviteId ? ActiviteId : null,
                                                                Deleted: false,
                                                            },
                                                        ], false));
                                                    }, disabled: !!activite.IsLectureSeule }, { children: _jsx(AddIcon, {}) })) })); } }), _jsx(FieldArray, { name: 'activite__collaborateurs', render: function (_a) {
                                                var values = _a.form.values, name = _a.name;
                                                return values[name] &&
                                                    values[name].map(function (item, index) {
                                                        if (item.Deleted) {
                                                            return;
                                                        }
                                                        return (_jsxs(Stack, __assign({ direction: "row" }, { children: [renderField({
                                                                    label: 'Collaborateur',
                                                                    name: "".concat(name, "[").concat(index, "].CollaborateurId"),
                                                                    type: TYPES.SELECT,
                                                                    options: collaborateurs,
                                                                    isRequired: true,
                                                                    disabled: !!values[name][index].IdActiviteCollaborateur ||
                                                                        !!activite.IsLectureSeule,
                                                                }), _jsx(IconButton, __assign({ tooltip: "Supprimer le collaborateur", color: "error", onClick: function () {
                                                                        setFieldValue("".concat(name, "[").concat(index, "].Deleted"), true);
                                                                    }, disabled: !!activite.IsLectureSeule }, { children: _jsx(DeleteIcon, {}) }))] }), index));
                                                    });
                                            } }), _jsx(Stack, { children: renderField({
                                                label: 'Synchroniser les agendas',
                                                name: "UseSynchroCalendar",
                                                type: TYPES.BOOLEAN,
                                                disabled: !!activite.IsLectureSeule,
                                            }) })] })), _jsxs(Stack, __assign({ className: "w-full", spacing: 2 }, { children: [_jsx(CardTitle, { title: "Contacts", startIcon: _jsx(ContactIcon, {}), renderButtons: function () { return (_jsx(_Fragment, { children: _jsx(IconButton, __assign({ color: "white", tooltip: "Ajouter un contact", onClick: function () {
                                                        setFieldValue('activite__contacts', __spreadArray(__spreadArray([], (values.activite__contacts
                                                            ? values.activite__contacts
                                                            : []), true), [
                                                            {
                                                                IsNew: true,
                                                                IdActiviteContact: null,
                                                                ContactId: null,
                                                                ActiviteId: ActiviteId ? ActiviteId : null,
                                                                Deleted: false,
                                                            },
                                                        ], false));
                                                    }, disabled: !!activite.IsLectureSeule }, { children: _jsx(AddIcon, {}) })) })); } }), _jsx(FieldArray, { name: 'activite__contacts', render: function (_a) {
                                                var values = _a.form.values, name = _a.name;
                                                return values[name] &&
                                                    values[name].map(function (item, index) {
                                                        if (item.Deleted) {
                                                            return;
                                                        }
                                                        return (_jsxs(Stack, __assign({ direction: "row" }, { children: [renderField({
                                                                    label: 'Contact',
                                                                    name: "".concat(name, "[").concat(index, "].ContactId"),
                                                                    type: TYPES.SELECT,
                                                                    options: contacts,
                                                                    isRequired: true,
                                                                    disabled: !!values[name][index].IdActiviteContact ||
                                                                        !!activite.IsLectureSeule,
                                                                }), _jsx(IconButton, __assign({ tooltip: "Supprimer le contact", color: "error", onClick: function () {
                                                                        setFieldValue("".concat(name, "[").concat(index, "].Deleted"), true);
                                                                    }, disabled: !!activite.IsLectureSeule }, { children: _jsx(DeleteIcon, {}) }))] }), index));
                                                    });
                                            } })] }))] })));
                    } })] }));
    };
    return (_jsx(_Fragment, { children: _jsx(Modal, __assign({ handleCloseModal: handleClose, forceOpen: true, title: "Activite", color: "activite", iconTitle: _jsx(ActiviteIcon, {}) }, { children: loading ? _jsx(Loader, {}) : renderForm() })) }));
};
//# sourceMappingURL=EditionActivite.js.map